import type { ReactNode } from 'react';

export type StaticPageContent = {
  eyebrow: string;
  title: string;
  intro: string;
  body: ReactNode;
};

export const staticPages: Record<string, StaticPageContent> = {
  '/quienes-somos': {
    eyebrow: 'Run More Chile',
    title: 'Quienes somos',
    intro:
      'Run More nace en Brasil con una idea simple: vestir el cuerpo en movimiento. Llegamos a Chile con la misma intencion: moda fitness premium, sin ruido, hecha para correr mas, entrenar mas, vivir mas.',
    body: (
      <>
        <h2>Nuestra historia</h2>
        <p>
          Empezamos como un proyecto familiar de moda fitness en Sao Paulo y crecimos hasta convertirnos en una de las marcas
          mas reconocidas de Brasil. En 2026 abrimos operacion oficial en Chile, con catalogo propio, despacho a todo el pais y
          un equipo local que entiende como entrena, corre y se mueve la mujer chilena.
        </p>
        <h2>Lo que nos mueve</h2>
        <p>
          Calidad antes que volumen. Calzas que no se transparentan, tops que sostienen sin apretar, telas que duran lavadas
          tras lavadas. Disenamos para entrenar, pero tambien para que la prenda quede bien dentro y fuera del gimnasio.
        </p>
        <h2>Comunidad Run More</h2>
        <p>
          Correndo Juntas es nuestro programa de comunidad: entrenamientos abiertos, eventos en regiones y embajadoras que viven
          la marca todos los dias. Si entrenas con nosotras, esta es tambien tu casa.
        </p>
        <h2>Sustentabilidad</h2>
        <p>
          Trabajamos con proveedores que reducen el uso de agua en la tincion, reutilizamos retazos en accesorios y empacamos
          en materiales reciclados. No somos perfectas, pero medimos y mejoramos cada coleccion.
        </p>
      </>
    )
  },
  '/contacto': {
    eyebrow: 'Hablemos',
    title: 'Contacto',
    intro:
      'Estamos para responderte. Si necesitas ayuda con un pedido, una talla o quieres ser parte de Correndo Juntas, escribenos por el canal que prefieras.',
    body: (
      <>
        <h2>Atencion al cliente</h2>
        <p>
          <strong>WhatsApp:</strong> <a href="https://wa.me/56900000000">+56 9 0000 0000</a>
          <br />
          <strong>Email:</strong> <a href="mailto:contacto@runmorechile.cl">contacto@runmorechile.cl</a>
          <br />
          <strong>Horario:</strong> Lunes a viernes de 09:00 a 18:00
        </p>
        <h2>Pedidos y despachos</h2>
        <p>
          Para consultar el estado de un pedido, ten a mano tu numero de orden (te lo enviamos por email tras la compra). El
          tiempo de respuesta promedio es de 24 horas habiles.
        </p>
        <h2>Prensa y colaboraciones</h2>
        <p>
          Si quieres colaborar con la marca, ser parte de Correndo Juntas o tienes un proyecto editorial, escribenos a{' '}
          <a href="mailto:prensa@runmorechile.cl">prensa@runmorechile.cl</a>.
        </p>
        <h2>Mayoristas</h2>
        <p>
          Tenemos catalogo mayorista para tiendas y gimnasios. Solicita acceso enviando tu RUT y datos comerciales a{' '}
          <a href="mailto:mayorista@runmorechile.cl">mayorista@runmorechile.cl</a>.
        </p>
      </>
    )
  },
  '/faq': {
    eyebrow: 'Preguntas frecuentes',
    title: 'Ayuda y soporte',
    intro:
      'Las dudas mas comunes que recibimos. Si no encuentras lo que buscas, escribenos por WhatsApp y te respondemos en horario habil.',
    body: (
      <>
        <h2>Despachos</h2>
        <p>
          <strong>Hacemos despacho a todo Chile</strong> via Starken. Region Metropolitana 2 a 3 dias habiles, regiones 3 a 7
          dias habiles segun zona. El despacho es gratis sobre $90.000.
        </p>
        <h2>Metodos de pago</h2>
        <p>
          Trabajamos con MercadoPago: tarjetas de credito, debito, transferencia y efectivo en puntos de pago. La compra se
          procesa en el sitio seguro de MercadoPago, no almacenamos datos de tarjeta.
        </p>
        <h2>Tallas</h2>
        <p>
          Cada producto tiene su guia de tallas en la ficha. Si dudas entre dos tallas, escribenos con tu medida de cintura y
          cadera y te recomendamos. La calza Run More tiene compresion media, no aprieta.
        </p>
        <h2>Cuidados de la prenda</h2>
        <p>
          Lavar a maquina con agua fria, programa delicado, sin suavizante. Secar a la sombra. No planchar las zonas con logo.
          Asi te dura mas y mantiene la compresion original.
        </p>
        <h2>Cambios y devoluciones</h2>
        <p>
          Tienes 30 dias desde la entrega para cambios y devoluciones, siempre que la prenda este sin uso, con etiqueta y en su
          empaque original. Revisa el detalle en{' '}
          <a href="/cambios">Cambios y devoluciones</a>.
        </p>
        <h2>Stock</h2>
        <p>
          Si una talla aparece como agotada, dejanos tu email en la ficha del producto y te avisamos cuando reponemos.
          Reabastecemos los productos basicos cada 2 a 3 semanas.
        </p>
      </>
    )
  },
  '/cambios': {
    eyebrow: 'Politica de cambios',
    title: 'Cambios y devoluciones',
    intro:
      'Queremos que la prenda te quede bien. Si algo no funciono, te lo cambiamos o devolvemos en pocos pasos. Lee las condiciones antes de iniciar el proceso.',
    body: (
      <>
        <h2>Plazos</h2>
        <p>
          Tienes <strong>30 dias corridos</strong> desde la fecha de entrega para solicitar un cambio o devolucion. Pasado ese
          tiempo no aceptamos solicitudes.
        </p>
        <h2>Condiciones</h2>
        <p>La prenda debe estar:</p>
        <ul>
          <li>Sin uso, sin lavar y sin olor</li>
          <li>Con la etiqueta original puesta</li>
          <li>En su empaque o bolsa original</li>
        </ul>
        <h2>Productos sin cambio</h2>
        <p>
          Por higiene no aceptamos cambios en bikinis, calzas interiores, accesorios ni medias. Tampoco aplica a productos
          marcados como <em>final sale</em> u outlet.
        </p>
        <h2>Como solicitar el cambio</h2>
        <ol>
          <li>Escribenos a <a href="mailto:cambios@runmorechile.cl">cambios@runmorechile.cl</a> con tu numero de pedido y el motivo.</li>
          <li>Te enviamos una etiqueta de retorno por Starken.</li>
          <li>Despachas la prenda desde tu sucursal mas cercana.</li>
          <li>Cuando la recibimos, validamos el estado y procesamos el cambio o devolucion.</li>
        </ol>
        <h2>Tiempos</h2>
        <p>
          El cambio se despacha apenas validamos la prenda recibida (1 a 3 dias habiles desde que llega a bodega). En caso de
          devolucion, el reembolso se procesa por el mismo medio de pago original (MercadoPago) y puede tardar entre 5 y 10
          dias habiles en aparecer en tu cuenta.
        </p>
        <h2>Costos</h2>
        <p>
          El primer cambio por talla es <strong>gratis</strong>. Los cambios siguientes o devoluciones por arrepentimiento
          tienen un costo de despacho de $4.990 que se descuenta del reembolso.
        </p>
      </>
    )
  }
};
